<div class="flex flex-col">
  <div *ngIf="!managingSatelliteLocation" class="md:mt-2">
    <div class="gap-5 flex flex-row gap-2 md:w-1/3">
      <button type="button" *ngIf="!managingSatelliteLocation && canEdit"
        mat-button color="primary" [disabled]="isCreating" (click)="createSatelliteLocation()">Add a Satellite Location</button>
      <button type="button" *ngIf="!managingSatelliteLocation"
        mat-button color="primary" class="ml-auto" (click)="getSatelliteLocations(!includeArchived)">
        {{includeArchived ? 'Hide Archived' : 'Show Archived'}}
      </button>
    </div>

    <div class="flex flex-col md:w-1/3">
      <mat-table [dataSource]="satelliteLocationSource" matSort #satelliteLocationSort="matSort" aria-label="On-Campus Buildings" class="portal-table">
        <ng-container matColumnDef="satelliteId">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">Satellite ID</mat-header-cell>
          <mat-cell *matCellDef="let building">
            <div *ngIf="building.satelliteId != ''">
              <span class="mobile-label">Satellite ID</span>
              {{ HospitalLicenseId }}-{{ building.satelliteId }}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="buildingName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">Satellite Name</mat-header-cell>
          <mat-cell *matCellDef="let building">
            <span class="mobile-label">Satellite Name</span>
            {{ building.buildingName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="archived">
          <mat-header-cell *matHeaderCellDef mat-sort-header=""></mat-header-cell>
          <mat-cell *matCellDef="let building">
            <span class="font-semibold" *ngIf="building.archived">Archived</span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="satelliteLocationColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: satelliteLocationColumns" class="portal-interactive-row"
                [ngClass]="row.archived? 'portal-archived' : ''" (click)="selectSatelliteLocation(row)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectSatelliteLocation(row))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectSatelliteLocation(row))"></mat-row>
      </mat-table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" #satelliteLocationPaginator="matPaginator">
      </mat-paginator>
    </div>
  </div>

   <div class="flex flex-col w-full" *ngIf="managingSatelliteLocation" [attr.inert]="isClosing ? '' : null" [@slideRight]>
    <p role="status" aria-live="polite">{{ saver?.status }}</p>
    <form [formGroup]="satelliteForm" class="flex flex-col w-full gap-4">

      <div flex flex-row>
        <div class="flex justify-between items-center gap-4 w-full">
          <div class="flex items-center gap-2">
            <span class="font-semibold" *ngIf="managingSatelliteLocation && !newSatelliteCreated">Managing Satellite Location</span>
            <span class="font-semibold" *ngIf="managingSatelliteLocation && newSatelliteCreated">Add a Satellite Location</span>
            <button type="button" *ngIf="managingSatelliteLocation && canEdit"
                    mat-button color="primary" [disabled]="isClosing" (click)="saveSatelliteLocation()">Save</button>
            <button type="button" *ngIf="managingSatelliteLocation"
                    mat-button color="warn" [disabled]="isClosing" (click)="closeWithSave()">Close</button>
          </div>
          <div class="flex items-center gap-2">
            <button type="button" mat-button color="warn" *ngIf="canEdit"
                    (click)="confirmDelete(satelliteLocation.id)">Delete</button>
          </div>
        </div>
      </div>

      <mat-card>
        <mat-card-content>
          <div class="flex flex-row gap-2 items-end">
            <div class="flex flex-col w-1/2 gap-2">
              <!-- <div flex flex-row>
                <div class="flex justify-between items-center gap-4 w-full">
                  <div class="flex items-center gap-2">
                    <span class="font-semibold" *ngIf="managingSatelliteLocation && !newSatelliteCreated">Managing Satellite Location</span>
                    <span class="font-semibold" *ngIf="managingSatelliteLocation && newSatelliteCreated">Add a Satellite Location</span>
                    <button type="button" *ngIf="managingSatelliteLocation && canEdit"
                            mat-button color="primary" [disabled]="isClosing" (click)="saveSatelliteLocation()">Save</button>
                    <button type="button" *ngIf="managingSatelliteLocation"
                            mat-button color="warn" [disabled]="isClosing" (click)="closeWithSave()">Close</button>
                  </div>
                  <div class="flex items-center gap-2">
                    <button type="button" mat-button color="warn" *ngIf="canEdit"
                            (click)="confirmDelete(satelliteLocation.id)">Delete</button>
                  </div>
                </div>
              </div> -->

              <div class="flex flex-row gap-2 pb-2 md:w-1/3">
                <span class="font-semibold">Building ID:</span>
                <span>{{HospitalLicenseId}}-{{satelliteLocation.satelliteId}}</span>
              </div>

              <div *ngIf="!canEdit" class="flex flex-col gap-2">

                <div class="flex flex-row gap-2">
                  <span class="font-semibold">Phone:</span>
                  <span>{{satelliteLocation.phone | mask:"000-000-0000"}}</span>
                </div>

                <div class="flex flex-row gap-2 md:w-2/3">
                  <span class="font-semibold">Name of the building:</span>
                  <span>{{satelliteLocation.buildingName}}</span>
                </div>
              </div>

              <div *ngIf="canEdit" class="flex flex-col gap-2">
                <div class="flex flex-col md:flex-row md:gap-4 items-center">
                  <mat-form-field class="flex md:w-1/3">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="phone" mask="000-000-0000" [readonly]="!canEdit">
                    <mat-error *ngIf="satelliteForm.get('phone')?.hasError('required')">
                      Phone number required
                    </mat-error>
                    <mat-error *ngIf="satelliteForm.get('phone')?.hasError('pattern')">
                      Format number as 000-000-0000
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="flex md:w-2/3">
                    <mat-label>Name of the building</mat-label>
                    <input matInput formControlName="buildingName">
                    <mat-error *ngIf="satelliteForm.get('buildingName')?.hasError('required')">
                      A building name is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <span>Enter the details for each floor and suite within the building in which you provide services:</span>

              <app-hospital-service-location
                [entityId]="satelliteLocation.id"
                [entityType]="entity"
                [showType]="true"
                [canEdit]="canEdit">
              </app-hospital-service-location>
            </div>

            <div class="flex flex-col w-1/2 gap-4">
              <address [entityId]="satelliteLocation.id"
                [entityType]="sharedService.satelliteLocation"
                [limitEntries]="true"
                [canEdit]="canEdit"
                (reportOutOfState)="updateOutOfState($event)">
              </address>
              <div class="flex flex-col w-full">
                <document
                  [entityId]="satelliteLocation.id"
                  [entityType]="sharedService.satelliteLocation"
                  [editable]="canEdit"
                  [types]="satelliteLocationTypes"
                  [statuses]="licenseStatuses">
                </document>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

    </form>
  </div>
</div>
